var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dashboardFooter"},[_c('div',{staticClass:"dashboardFooter-api"},[_c('button-com',{staticClass:"bm-ghost bm-onlyIcon",attrs:{"iconName":"link","iconSize":"large","iconColor":"#888","tooltip":""},nativeOn:{"click":function($event){_vm.goTo('//api.lootbox.se/v1/feed/' + _vm.feedId)}}})],1),_vm._v(" "),_c('usernav-com')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c8562906","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/DashboardFooter.vue
// module id = LheX
// module chunks = 0